<template>
  <ul class="kp-tab-edit">
    <basic-option></basic-option>
    <naked-option></naked-option>
    <external-option></external-option>
  </ul>
</template>

<script>
import BasicOption from './Basic.vue';
import NakedOption from './Naked.vue';
import ExternalOption from './External.vue';

export default {
  components: {
    BasicOption,
    NakedOption,
    ExternalOption,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?7e49db8b
 **/